snt-icon-copy {
  @include applyAlignmentTheme("content");

  h3 {
    text-align: center;
    margin-bottom: 15px;
  }

.cta-margin{
margin-bottom: 30px;
}
.cta-container{
  display: flex;
  justify-content: center;
  margin-top: auto;
}
.cta-container snt-link{
  justify-content: center;
  display: grid;
}
  .icon-copy-cta, .icon-copy-cta button  {
  width: 100% !important;
}
.cta-container a.cta{
  padding: 0 0 13px 0;
}

  .icon { 
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0px auto 40px;
    box-sizing: border-box;
    height: 60px;
    width: 60px;
    border: 3px solid $color-secondary-medium;
    background-color: $color-secondary-medium;
    border-radius: 150px;

    @include applyThemeMap($icon-copy-icon-themes);
  }

  .icon-image {
    height: 30px;
    width: 30px;
  }

  .icon-copy-panel {
    width: 100%;
    box-sizing: border-box;
    border: 3px solid $color-grey-06;
    padding: 40px 20px;
    display: flex;
    flex-direction: column;

    @include applyThemeMap($icon-copy-themes);
  }

  .hidden {
    display: none;
  }

  .logo {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0px auto 40px;
    height: 60px;
    width: 214px;
  }

  .logo-image {
    height: 60px;
    width: 214px;
  }

  @include viewport($viewport-md) {
    h3 {
      margin-bottom: 20px;
    }
    .logo {
      height: 60px;
      width: 286px;
    }
    .logo-image {
      height: 60px;
      width: 286px;
    }
  }

  @include viewport($viewport-lg) {
    h3 {
      margin-bottom: 25px;
    }

    .icon {
      height: 80px;
      width: 80px;
    }

    .icon-image {
      height: 45px;
      width: 45px;
    }

    .logo {
      height: 80px;
      width: 227px;
    }

    .logo-image {
      height: 80px;
      width: 227px;
    }
  }

  @include viewport($viewport-xl) {
    h3 {
      margin-bottom: 30px;
    }

    .icon {
      height: 80px;
      width: 80px;
    }

    .icon-image {
      height: 45px;
      width: 45px;
    }

    .logo {
      height: 80px;
      width: 323px;
    }

    .logo-image {
      height: 80px;
      width: 323px;
    }
  }

  &.link {
    snt-action-link,
    snt-link,
    a {
      display: flex;
      align-items: stretch;
    }
    h2 {
      font-size: 1.75rem;
      line-height: 2.125rem;
      text-align: center;
      margin-bottom: 1.875rem;
    }
    p {
      text-align: center;
    }
    .icon-copy-panel {
      border: 3px solid transparent;
      box-shadow: 0.2px 0.2px 10px $color-grey-06;
      margin: 10px;
      color: initial;
      width: calc(100% - 22px);
      outline-offset: 3px;
      outline: 1px dashed transparent;
    }
    a {
      background-image: none;
      border: none;
      text-decoration: none;
      outline: none;
      margin: 0;
      padding: 0;
      &:active,
      &:hover {
        background-image: none;
        margin: 0;
        padding: 0;
        .icon-copy-panel {
          border: 3px solid $color-primary-accent;
        }
      }
      &:focus {
        outline: none;
        margin: 0;
        padding: 0;
        .icon-copy-panel {
          outline: 1px dashed $color-black;
        }
      }
      &:before {
        display: none;
      }
    }
  }
}
.light-fill {
  snt-icon-copy{
    .cta.theme-default a, .cta.theme-default button {
      background: #323232;
      color: #FFFFFF;
      box-shadow: inset 0 0 0 3px #323232;
      border-radius: 25px;
      &:hover {
        background-color: #d9f0f4;
        color: #323232;
        box-shadow: inset 0 0 0 3px #323232;
      }
      &:focus{
          color: $color-white;
          background: $color-primary-grey;
          outline: 1px solid $color-primary-grey;
          outline-offset: 3px;
      }
      &:active{
        color: $color-primary-pressed;
        background: #d9f0f4;
        border: $color-primary-pressed;
        box-shadow: inset 0 0 0 3px $color-primary-pressed;
       }
    }
   .cta-container snt-link a {
      &:hover{
        background-image:none;
      }
    }
  }

}
